import React from "react"
import PropTypes from "prop-types"
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap'

const ConfirmModal = (props) => {
    const {isOpen, title, message, onCancel, customOkButton, customCancelButton, onOk, cancelText, className = '', closeIcon} = props

    const cancelButton = React.cloneElement(
        customCancelButton,
        {onClick: onCancel},
        (customCancelButton.props.children) || cancelText
    )

    const okButton = React.cloneElement(
        customOkButton,
        {onClick: onOk},
        (customOkButton.props.children) || cancelText
    )

    return (
        <div className="ConfirmModal">
            <Modal
                isOpen={isOpen}
                className={`modal-dialog-centered PFModal ${className}`}
                toggle={onCancel}
            >
                <ModalHeader
                    close={closeIcon}
                    toggle={onCancel}
                >
                    {title}
                </ModalHeader>
                <ModalBody>
                    {message}
                </ModalBody>
                <ModalFooter>
                    {cancelButton}
                    {okButton}
                </ModalFooter>
            </Modal>
        </div>
    )
}

ConfirmModal.defaultProps = {
    title: 'Title',
    message: 'Are you sure?',
    closeIcon: undefined,
    cancelText: 'Cancel',
    className: '',
    okText: 'OK',
    customOkButton: <button className="btn btn-primary"/>,
    customCancelButton: <button className="btn btn-outline-primary"/>
}

ConfirmModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
    className: PropTypes.string,
    title: PropTypes.string,
    message: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    closeIcon: PropTypes.node,
    cancelText: PropTypes.string,
    okText: PropTypes.string,
    customOkButton: PropTypes.object,
    customCancelButton: PropTypes.object,
}

export default ConfirmModal
